<form class="container pt-5" (ngSubmit)="loginUser()" #loginForm="ngForm" name="loginUser" method="post">
    <h1>User Login</h1>
    <div id="errorSummary" class="text-danger" [innerHTML]="errorList.outerHTML"></div>
    <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input type="email" class="form-control" id="email" [(ngModel)]="model.email" #email="ngModel" [ngModelOptions]="{standalone: true}" required email>
        <span id="clientEmailValidationMessage" class="text-danger" *ngIf="email.invalid && (email.dirty || email.touched)">
            <span *ngIf="email.errors?.['required']">Email is required.</span>
            <span *ngIf="email.errors?.['email']">Invalid email address.</span>
        </span>
        <span id="serverEmailValidationMessage" class="text-danger">{{emailErrorMsg}}</span>
    </div>
    <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input type="password" class="form-control" id="password" [(ngModel)]="model.password" #password="ngModel" [ngModelOptions]="{standalone: true}" required>
        <span id="clientPasswordValidationMessage" class="text-danger" *ngIf="password.invalid && (password.dirty || password.touched)">
            <span *ngIf="password.errors?.['required']">Password is required.</span>
        </span>
        <span id="serverPasswordValidationMessage" class="text-danger">{{passwordErrorMsg}}</span>
    </div>
    <div class="form-check mb-3">
        <input class="form-check-input" type="checkbox" value="" id="rememberMe" [(ngModel)]="model.rememberMe" #rememberMe="ngModel" [ngModelOptions]="{standalone: true}">
        <label for="rememberMe" class="form-check-label" for="flexCheckDefault">
            Remember Me
        </label>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid">Login</button>
</form>
